import { Button, Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';

const FormErrorCode: React.FC<any> = (props) => {
  const { dataEditModal, isEdit, form, handleAddErrorCode, handleEditErrorCode } = props;
  console.log('dataEditModal', dataEditModal);

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  // for Submit
  const handleSubmit = (data: any) => {
    const payload = {
      ...data,
    };
    if (isEdit) {
      handleEditErrorCode(payload);
    } else {
      handleAddErrorCode(payload);
    }
  };

  useEffect(() => {
    if (dataEditModal) {
      form.setFieldsValue(dataEditModal);
    }
  }, [dataEditModal, form]);

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={['onBlur', 'onInput']}
        autoComplete="off"
      >
        <Row gutter={30}>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Text
              name="code"
              label="Error Code"
              required
              rules={[validations.required.text('Error Code')]}
              disabled={isEdit ? true : false}
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Text
              name="code_name"
              label="Error Code Name"
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Select
              label="Error Code Value"
              name={'code_value'}
              options={{
                list: [
                  {
                    id: 'Success',
                    value: 'Success',
                  },
                  {
                    id: 'Failed',
                    value: 'Failed',
                  },
                ],
                valueKey: 'id',
                textKey: 'value',
              }}
              required
              rules={[validations.required.select('Error Code Value')]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Text
              name="description"
              label="Error Code Description"
            />
          </Col>
          <Col
            xs={24}
            md={12}
            lg={6}
          >
            <Button
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormErrorCode;
